import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { ConfirmModal } from 'components/project/ClerkScreen';
import {
  ButtonContainer,
  EndLaneButton,
  RestartLastLaneButton,
} from './Styles';

const EndLane = () => {
  const {
    AuctionStore: { auctionLaneName, laneStatus },
    ProviderStore: { getProviderSettingByKey },
    UIStore: { handleEndLane, handleReJoinLastLane },
  } = useStores();

  const message = `Ending the '${auctionLaneName}' lane will send the following message to all online users on this lane:\n\n"${getProviderSettingByKey(
    'LaneEndMessage',
  )}"`;

  if (laneStatus === 'Running') {
    return (
      <ButtonContainer>
        <ConfirmModal
          title="Are you sure you would like to end the lane?"
          message={message}
          confirmText="End Lane"
          onConfirm={() => handleEndLane(getProviderSettingByKey('LaneEndMessage'))}
          renderLink={(modal) => (
            <EndLaneButton onClick={modal.open}>
              <i className="fa fa-stop-circle fa-2" aria-hidden="true" />
              End
              Lane
            </EndLaneButton>
          )}
        />
      </ButtonContainer>
    );
  }

  if (laneStatus === 'Ended') {
    return (
      <ButtonContainer>
        <RestartLastLaneButton onClick={handleReJoinLastLane}>
          <i className="fa fa-play-circle fa-2" aria-hidden="true" />
          Restart Last Lane
        </RestartLastLaneButton>
      </ButtonContainer>
    );
  }

  return null;
};

export default observer(EndLane);
